const Cross = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M17.4569 7.55735C17.8474 7.16683 17.8474 6.53366 17.4569 6.14314C17.0664 5.75261 16.4332 5.75261 16.0427 6.14314L11.8 10.3858L7.55741 6.14314C7.16688 5.75261 6.53372 5.75261 6.1432 6.14314C5.75267 6.53366 5.75267 7.16682 6.1432 7.55735L10.3858 11.8L6.14319 16.0426C5.75267 16.4332 5.75267 17.0663 6.14319 17.4568C6.53372 17.8474 7.16688 17.8474 7.55741 17.4568L11.8 13.2142L16.0427 17.4568C16.4332 17.8474 17.0664 17.8474 17.4569 17.4568C17.8474 17.0663 17.8474 16.4332 17.4569 16.0426L13.2143 11.8L17.4569 7.55735Z" fill="currentColor"/>
    </svg>
  );
};

export default Cross;